import RecommendationSlider from '@personalization/scripts/components/RecommendationSlider.jsx';
import Layer from '@bonprix/pattern-library/components/layer';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import Icon from '@bonprix/pattern-library/templates/icon';
import React, { useEffect, useState } from 'react';
import CoreMessages from '../messages';
import ProductInfo from './ProductInfo.jsx';

export default function IntoCartLayer({
    article,
    texts,
    pageLandmark,
    intoCartLayerGotoCartButtonUrl,
    intoCartLayerIntoCartClickLandmarkValue,
    intoCartLayerGoOnShoppingClickLandmarkValue,
    ajaxSwiperDataUrl,
    ajaxSwiperParamString,
    layerId,
}) {
    const [open, setOpen] = useState(true);

    const close = () => setOpen(false);

    useEffect(() => {
        MessageBroker.subscribe(CoreMessages.LAYER.OPEN, (data) => {
            if (layerId === data.layerId) {
                setOpen(true);
            }
        });
    }, []);

    return (
        <Layer className="into-cart__layer" opened={open} onClose={close} testRefs={{ 'test-ref__into-cart-layer': '' }}>
            <div
                className="into-cart__layer-content"
                jsh-landmark={pageLandmark ? '' : null}
                jsh-landmark__page={pageLandmark}
            >
                <div className="into-cart__layer-headline">
                    <Icon name="check" />
                    <div className="into-cart__layer-headline-message">{texts.bff_layer_add_to_basket_headline}</div>
                </div>
                <div className="into-cart__layer-content-inner">
                    <ProductInfo
                        article={article}
                        texts={texts}
                        intoCartClickLandmarkValue={intoCartLayerIntoCartClickLandmarkValue}
                        closeFunction={close}
                        gotoCartButtonUrl={intoCartLayerGotoCartButtonUrl}
                        goOnShoppingClickLandmarkValue={intoCartLayerGoOnShoppingClickLandmarkValue}
                    />
                </div>
                <div className="into-cart__swiper-container">
                    {article && (
                        <RecommendationSlider
                            className="into-cart__recommendations"
                            paramStringWithPageViewId={ajaxSwiperParamString + '&origin=into-cart'}
                            swiperDataUrl={ajaxSwiperDataUrl}
                            imagesOnly
                            sliderType="reco"
                        />
                    )}
                </div>
            </div>
        </Layer>
    );
}
